// DialogWrapper.js
import { Children, useState, useEffect } from "react";
import { Rnd } from "react-rnd"
import { Button, Box } from '@mui/material'


const defaultRndStyle = { x: 0, y: 0, width: 320, zIndex:'3000'}

/**
 * The drag and drop component of a generic swmmReact model input dialog.
 * 
 * @param {JSX} children The inputs, controls, and charts the dialog will display.
 * @param {function} handleClose Called when the user or the program needs to close this dialog.
 * @param {function} handleZIndexAssign Sets the z-index of the dialog.
 * @param {number} minHeight Provides a reasonable viewing window for the dialog.
 * @param {object} position The location of the dialog, when it is visible.
 * @param {function} setPosition Sets the visible location of the dialog.
 * @returns 
 */
const DialogWrapper = ({ children, handleClose, handleZIndexAssign, minHeight, position, setPosition }) => {
  const [zIndex, setZIndex] = useState(3000)

  const boxStyle = {
    bgcolor: 'background.paper',
    border: '5px solid rgba(200, 200, 200, 0.1)',
    borderRadius: '15px', 
    boxShadow: 24,
    p: 4,
    flex: 1,
    flexGrow: '1', 
    //height:'calc(100% - 50px)', 
    flexDirection: 'column',
    display: 'flex',
  }

  const rndStyle = { 
    display: 'flex', 
    flexDirection:'column'
  }

  const closeButtonStyle = {
    height: '36.5px', 
    width: '50px', 
    right:'0', 
    display:'flex', 
    marginLeft:'auto'
  }

  const dialogChildStyle = { 
    flexGrow: '1', 
    //height:'calc(100% - 50px)', 
    flexDirection: 'column',
    display: 'flex',
    backgroundColor:'black'
  }

  // bring the zIndex to the front if the user clicks on the dialog
  const zIndexAssign = () => {
    setZIndex(handleZIndexAssign())
  }

  // When the component is first loaded, give it the top zIndex
  useEffect(()=> {
    zIndexAssign()
  }, [])

  /** If there are no children, don't create a wrapper. */
  if(Children.toArray(children).length > 0){
    return (
      <>
        <Rnd style={{...rndStyle, zIndex: zIndex, cursor: 'default'}} default={{...defaultRndStyle, x: position.x, y: position.y, width: position.width, height: position.height}} minHeight={minHeight} minWidth={100} onDragStop={(e, d) => { zIndexAssign(); setPosition(prev =>({...prev, x: d.x, y: d.y })) }} onResizeStop={(e, d, ref) => { zIndexAssign(); setPosition(prev =>({...prev, width: ref.style.width, height: ref.style.height })) }} cancel='Button, input, select, pre, textarea, span, .cm-line' >
          <Box className="modal-objectmodal" sx={boxStyle} onClick={()=>{ zIndexAssign() }} >
            <Button style={closeButtonStyle} onClick={()=>handleClose()}>Close</Button>
          
            <div style={dialogChildStyle}>
              {children}
            </div>
          </Box>
        </Rnd>
      </>
    )
  } else {
    return null
  }
}

export default DialogWrapper